import { combineReducers } from 'redux';

import {
  clearPromotionCodeList,
  getPromotionCodeListFail,
  getPromotionCodeListRequest,
  getPromotionCodeListSuccess,
  setPromotionCodeListDirty,
} from '../actions';
import { PromotionCodeAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { PromotionCode } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<PromotionCode>>;
type ReducerOf<T extends keyof State> = Reducer<State, PromotionCodeAction, T>;


const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getPromotionCodeListRequest.type:
      return state ? stripItems(state) : null;

    case getPromotionCodeListSuccess.type:
      return action.payload;

    case clearPromotionCodeList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getPromotionCodeListRequest.type:
      return true;

    case getPromotionCodeListSuccess.type:
    case getPromotionCodeListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setPromotionCodeListDirty.type:
      return action.payload;

    case getPromotionCodeListSuccess.type:
    case getPromotionCodeListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
